import { h } from 'vue'
import { useTemplate } from '../../../hooks/index'

export default {
  props: {
    value: [Array, Object, String, Number, Boolean],
    column: Object,
    extendCompileData: Object,
  },
  setup(props, { emit }) {
    const { getTemplateData, compileData } = useTemplate()
    const propsColumn = props.column
    const keys = Object.keys(propsColumn.parameter ?? {})
    const parameter = keys.reduce((pre, cur) => {
      if (cur !== 'changeBorthers' && cur !== 'beforValueAction') {
        pre[cur] = propsColumn.parameter[cur]
      }
      return pre
    }, {})
    return () => {
      console.log('batch-cell-render')
      const propsCompileData = getTemplateData(null, { ...props.extendCompileData })
      const childProps = compileData(parameter, propsCompileData)
      const coverProps = {}
      //解决日期选择时浮动框自动被关闭
      if (propsColumn.componentCode === 'panguDatePicker') {
        coverProps.transfer = false
      }
      return h(propsColumn.componentCode, {
        style: propsColumn.style,
        attrs: { value: props.value, ...childProps, ...coverProps },
        on: {
          input: (val) => {
            emit('input', val)
          },
        },
      })
    }
  },
}
